var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleChevronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_33628",
    "data-name": "Group 33628",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9764",
    "data-name": "Rectangle 9764",
    width: 16,
    height: 16,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33627",
    "data-name": "Group 33627",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70485",
    "data-name": "Path 70485",
    d: "M8,16a8,8,0,1,1,8-8,8.015,8.015,0,0,1-8,8M8,1.321A6.679,6.679,0,1,0,14.679,8,6.691,6.691,0,0,0,8,1.321",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70486",
    "data-name": "Path 70486",
    d: "M12.171,10.551a.738.738,0,0,0-.206-.5L8.58,6.706a.709.709,0,0,0-1,0L4.2,10.052a.738.738,0,0,0-.206.5.7.7,0,0,0,.206.489.709.709,0,0,0,1,0L8.081,8.183l2.887,2.857a.709.709,0,0,0,1,0,.7.7,0,0,0,.206-.489",
    transform: "translate(-0.085 -1.607)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChevronUp);
export default __webpack_public_path__ + "static/media/circle-chevron-up.edc5a42a05a9a524d0072554048fb17c.svg";
export { ForwardRef as ReactComponent };